import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { getLeadDetailsById } from '@app/services/lead';
import Table from '@app/components/datatable/Table';
import UpdateLeadStatusModal from './UpdateLeadStatusModal';
import { getSubjectsByFranchise } from '@app/services/franchise';
import AddSubjectLeadModal from './AddSubjectLeadModal';
import UpdateLeadDetailsModal from './UpdateLeadDetailsModal';

const ViewJourney = () => {

    let { lead_id } = useParams();
    let obj: any = {}
    const [leadDetails, setLeadDetails] = useState(obj);
    const [leadJourney, setLeadJourney] = useState([]);
    const [leadSubjects, setLeadSubjects] = useState([]);
    const [franchiseSubjects, setFranchiseSubjects] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const canAccess = useSelector((state: any) => state.auth.permissions.lead)
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);
    const [selectedSubId, setSelectedSubId] = useState(0);

    const navigate = useNavigate()
    const [t] = useTranslation()
    useEffect(() => {
        if(canAccess['view-journey'] == false){
            toast.error(t('auth.noAccess'))
            navigate('/')
        }

        getLeadDetails()
    }, [])
      
    const getLeadDetails = async () => {
        try {
            setLoading(true);
            const resp = await getLeadDetailsById(lead_id);
            if (resp?.success === true) {
                setLoading(false);
                setLeadDetails(resp?.collections)
                setLeadSubjects(resp?.collections?.subjects)
                getFranchiseSubjects(resp?.collections?.franchise_id)
                if(resp?.collections?.subjects.length > 0){
                    setSelectedSubId(resp?.collections?.subjects[0].subject_id)
                    setLeadJourney(resp?.collections?.subjects[0].journey)
                }
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
                navigate(-1)
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error')
        }
    };

    const getFranchiseSubjects = async (franchise_id) => {
        try {
            const resp = await getSubjectsByFranchise(franchise_id)
            if (resp.success === true) {
                setFranchiseSubjects(resp?.collections.filter((sub) => sub.status == 'active'))
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const columns = [
        {
            name: 'Status',
            selector: (row: { status: string; }) => row.status,
            cell: (row: { status: string; }) => (
                row.status === 'Enrolled and Paid' ? <span className="badge bg-success">Enrolled and Paid</span> : <span className="capitalize badge bg-info">{row.status}</span>
            ),
            sortable: false,
        },
        {
            name: 'Comment',
            selector: (row: { comment: string }) => row.comment, 
            sortable: false,
            wrap: true
        },
        {
            name: 'Updated On',
            selector: (row: { status_updated_date: string; }) => row.status_updated_date ? moment(row.status_updated_date).format('DD-MM-YYYY') : '---',
            sortable: false,
        },
    ];

    const handleSubjectChange = async (subject_id) => {
        setSelectedSubId(subject_id)
        let subject = leadDetails?.subjects.filter((obj) => obj.subject_id == subject_id)
        setLeadJourney(subject[0].journey);
    };

    return (
        <>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <span style={{fontSize: '1.5rem', fontWeight: 'bold'}}>Lead Journey</span>
                        </div>
                        <div className="col-12">
                            <div className="external-event" style={{backgroundColor: "#ffd316", position: 'relative', zIndex: 'auto', left: '0px', top: '0px', width: '12%', fontWeight: 600, cursor:'default'}}>Lead Details</div>
                            <div className="card">
                                <div className="card-body" style={{backgroundColor: '#f9f1cc'}}>
                                    <div className="row d-flex justify-content-end">
                                        { canAccess['edit'] && (
                                            <Button type="button" isLoading={isLoading} className="btn btn-default btn-sm mr-2" onClick={ (e) => { handleShow3() }} data-toggle="tooltip" title="Edit Lead Details"><i className="fas fa-pen"></i></Button>
                                        )}
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Franchise Name</dt>
                                                <dd className='form-control-plaintext'>{ leadDetails?.franchise_name ?? '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Centre Name</dt>
                                                <dd className='form-control-plaintext'>{ leadDetails?.centre_name ?? '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Enquiry Date</dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.inquiry_date ? moment(leadDetails?.inquiry_date).format('DD/MM/YYYY') : '---'} </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Assessment Location</dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.assessment_location ?? '---'} </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Parent Name </dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.parent_name ?? '---' } </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Contact Number </dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.parent_phone ?? '---' } </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Email Address </dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.parent_email ?? '---' } </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>How They Got In Touch ? </dt>
                                                <dd className='form-control-plaintext'>{ leadDetails?.got_in_touch_id != '7' ? leadDetails?.got_in_touch : leadDetails?.got_in_touch_other_text }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Student Name</dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.student_name ?? '---'} </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Student Age</dt>
                                                <dd className="form-control-plaintext">{ leadDetails?.age ? leadDetails?.age + ' Years old' : '---'} </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Subject(s)</dt>
                                                <dd className='form-control-plaintext'>{ leadDetails?.subjects ? leadDetails?.subjects.map.call(leadDetails?.subjects, function(obj) { return obj.subject_name; }).join(", ") : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Where Did You Find About Us ?</dt>
                                                <dd className='form-control-plaintext'>{ (leadDetails?.found_us_id == '8' || leadDetails?.found_us_id == '9') ? leadDetails?.found_via_other_text : leadDetails?.found_us_via }</dd>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Lead Journey</h3>
                                    <div className='d-flex justify-content-end'>
                                        <div className="row">
                                            <div className="ml-2">
                                                { canAccess['add-lead-subject'] && franchiseSubjects.length - leadSubjects.length > 0 &&
                                                    <button type="button" className="btn btn-default btn-sm mr-2" onClick={ (e) => { handleShow2() }} data-toggle="tooltip" title="Add Subject">
                                                        <i className="fas fa-plus"></i>
                                                    </button>
                                                }
                                                { canAccess['status-update'] && leadJourney.length > 0 && leadJourney[0].lead_inquiry_status_id != 7 && (
                                                    <Button type="button" isLoading={isLoading} className="btn btn-default btn-sm mr-2" onClick={ (e) => { handleShow() }} data-toggle="tooltip" title="Update Lead Status"> <i className="fas fa-pen"></i></Button>
                                                )}
                                                <button type="button" className="btn btn-default btn-sm" onClick={() => navigate(-1)} data-toggle="tooltip" title="Back">
                                                    <i className="fas fa-reply"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div className="card-body">
                                    <div className='row mb-3'>
                                        <div className="col-sm-4">
                                            <label>You are viewing lead journey for the subject</label>
                                            <select
                                                className="form-control"
                                                name="subjectId"
                                                onChange={(e) => handleSubjectChange(e.target.value)}
                                                value={selectedSubId}
                                            >
                                                {leadSubjects.map((obj) => (
                                                    <option key={obj.subject_id} value={obj.subject_id}>
                                                        {obj.subject_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <Table
                                        columns={columns}
                                        data={leadJourney}
                                        pagination
                                        // selectableRows
                                        progressPending={ isLoading }
                                    />
                                </div>
                                {/* /.card-body */}
                            </div>
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
            </section>
            <UpdateLeadStatusModal
                show={show}
                handleClose={handleClose}
                reload={getLeadDetails}
                payload={leadDetails}
                type='view-journey'
            />

            <AddSubjectLeadModal
                show={show2}
                handleClose={handleClose2}
                reload={getLeadDetails}
                payload={leadDetails}
                type='view-journey'
                franchiseSubjects={franchiseSubjects}
            />

            <UpdateLeadDetailsModal
                show={show3}
                handleClose={handleClose3}
                reload={getLeadDetails}
                payload={leadDetails}
            />
            {/* /.content */}
        </>
    )
};

export default ViewJourney;